/**
 * Auth thunks sometimes reject with a string and sometimes with
 * `{ message, code, status }`. React cannot render the object.
 */
export function toAuthErrorMessage(error: unknown): string | null {
  if (error == null) return null;
  if (typeof error === 'string') return error || null;
  if (typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message) return message;
  }
  return null;
}

export function isConnectionAuthError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as { code?: unknown; status?: unknown };
  return (
    err.code === 'ERR_CONNECTION_REFUSED' ||
    err.code === 'ECONNABORTED' ||
    err.status === 0
  );
}
